import { render, staticRenderFns } from "./RichTextEditorMenuBar.vue?vue&type=template&id=338084a5&scoped=true&"
import script from "./RichTextEditorMenuBar.vue?vue&type=script&lang=js&"
export * from "./RichTextEditorMenuBar.vue?vue&type=script&lang=js&"
import style0 from "./RichTextEditorMenuBar.vue?vue&type=style&index=0&id=338084a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338084a5",
  null
  
)

export default component.exports